import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import OpsLogo from "../ops-library/ops-logo";
import OpsBtn from "../ops-library/ops-btn";
import OpsText from "../ops-library/ops-text";
import {FaFacebookSquare} from "react-icons/fa";
import {GrInstagram, GrYoutube} from "react-icons/gr";

const Footer = ({resortFooter, resortName, resortLogo, resortDomain}) => {

    const navigate = useNavigate();
    const [theme, setTheme] = useState(
        localStorage.getItem("theme") != null
            ? localStorage.getItem("theme")
            : "light"
    );


    return (
        <div className="footer-container position-relative px-2 pb-3 fa-w-100 mt-5">
            <div className="fa-flex-col align-items-center">
                <OpsBtn
                    btnText
                    text="Ľudová hudba Beťarky"
                    textColor="color-1"
                    fontWeight={400}
                    textStyle="text-center my-1"
                    action={() => navigate('/prihlasenie')}
                />

                <OpsText type="normal" weight={400} color="color-1"
                         content={new Date().getFullYear()}/>
            </div>
        </div>
    );
};

export default Footer;